import { Controller, useForm } from "@pankod/refine-react-hook-form";
import { Edit, Box, TextField, Autocomplete, Grid } from "@pankod/refine-mui";
import { IRole } from "interfaces";

const roles: IRole[] = [
  {
    id: 3,
    name: "Administrador",
  },
  {
    id: 5,
    name: "Administrativo",
  },
  {
    id: 6,
    name: "Cliente",
  },
  {
    id: 4,
    name: "Consulta",
  },
];

export const UserEdit: React.FC = () => {
  const {
    refineCore: { formLoading, onFinish },
    saveButtonProps,
    register,
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm({
    refineCoreProps: {
      metaData: {
        populate: ["role"],
      },
    },
  });

  const onSubmit = (data: any) => {
    if (data.password === "") {
      delete data.password;
    }
    onFinish({
      ...data,
    });
  };

  return (
    <Edit
      isLoading={formLoading}
      saveButtonProps={{
        ...saveButtonProps,
        onClick: handleSubmit(onSubmit),
      }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Controller
              control={control}
              name="role"
              rules={{ required: "Tipo es obligatorio" }}
              defaultValue={null as any}
              render={({ field }) => {
                return (
                  <Autocomplete
                    {...field}
                    options={roles}
                    onChange={(_, value) => {
                      field.onChange(value?.id);
                    }}
                    getOptionLabel={(item) => {
                      const value = item?.id ?? item;
                      return roles?.find((p) => p?.id === value)?.name ?? "";
                    }}
                    isOptionEqualToValue={(option, value) => {
                      const select = value?.id ?? value;
                      return (
                        value === undefined ||
                        option.id.toString() === select.toString()
                      );
                    }}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          label="Tipo"
                          margin="normal"
                          variant="outlined"
                          error={!!errors.role}
                          helperText={errors.role?.message?.toString()}
                          required
                          autoFocus
                        />
                      );
                    }}
                  />
                );
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              {...register("username", { required: "Usuario es obligatorio" })}
              error={!!errors?.username}
              helperText={errors.username?.message?.toString()}
              margin="normal"
              required
              fullWidth
              id="username"
              label="Usuario"
              name="username"
              defaultValue={" "}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              {...register("email", {
                required: "Correo es obligatorio",
                validate: (value) => {
                  return value?.includes("@") || "Correo no válido";
                },
              })}
              error={!!errors?.email}
              helperText={errors.email?.message?.toString()}
              margin="normal"
              fullWidth
              id="email"
              label="Correo"
              name="email"
              required
              defaultValue={" "}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("password", {
                minLength: {
                  value: 5,
                  message: "Contraseña debe tener al menos 8 caracteres",
                },
              })}
              id="password"
              margin="normal"
              fullWidth
              name="password"
              label={"Contraseña"}
              helperText={errors?.password?.message?.toString()}
              error={!!errors.password}
              type="password"
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("repeat_password", {
                minLength: {
                  value: 5,
                  message: "Contraseña debe tener al menos 8 caracteres",
                },
                validate: (value) => {
                  return (
                    value === getValues("password") ||
                    "Contraseñas no coinciden"
                  );
                },
              })}
              id="repeat_password"
              margin="normal"
              fullWidth
              name="repeat_password"
              label={"Repetir contraseña"}
              helperText={errors?.repeat_password?.message?.toString()}
              error={!!errors.repeat_password}
              type="password"
              required
            />
          </Grid>
        </Grid>
      </Box>
    </Edit>
  );
};
